
import React from "react";
import { LegalWorkLogView } from "./LegalWorkLogPage";
import { useAuth } from "../context/AuthContext";
import { canViewWorklog } from "../config/roles";

export function TasksAndLogsPage() {
  const { user } = useAuth();

  // Strict Access Control: KC & AD only
  if (!canViewWorklog(user?.email)) {
      return (
        <div style={{
            height:'100%', display:'flex', alignItems:'center', justifyContent:'center', 
            flexDirection:'column', color:'var(--danger)'
        }}>
            <h2 style={{margin:0}}>403 Forbidden</h2>
            <p>您的帳號 ({user?.email}) 無權存取工作日誌與待辦管理。</p>
        </div>
      );
  }

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="row" style={{ borderBottom: '1px solid #333', marginBottom: 16, justifyContent:'space-between', alignItems:'center' }}>
        <div className="row">
            <button 
            className="navbtn active" 
            style={{ width: 'auto', borderBottom: '2px solid #fff', borderRadius: 0, color: '#fff' }}
            >
            法務工作日誌
            </button>
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto' }}>
        <LegalWorkLogView />
      </div>
    </div>
  );
}
